import React, {useEffect, useState} from 'react';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import {connect} from 'react-redux';
import TestForm from '../forms/TestForm1';

import {getUsers, getAdmins, getKuliahs} from './dashboard.actions';

 const UserDashboard = (props, state) => {
  
  useEffect(() => {
  }, []);

  const [modal, setModal] = useState(false);
  const [modalinitial, setModalinitial] = useState(0);

  const toggle = () => setModal(!modal);

    return (
      <div>
   
    <TestForm/>
    <Button color="danger" onClick={toggle}>{'Cancel'}</Button>
       <Modal isOpen={modal} toggle={toggle} >
         <ModalHeader toggle={toggle}>Modal title</ModalHeader>
         <ModalBody>
           {modalinitial === 0 ?
           <div>
         The information provided on TCD Form Builder, The Complete Divorce platforms, and this website is not legal advice, does not constitute a lawyer referral service, and no attorney-client or confidential relationship is or will be formed by use of this website. This website is designed for informational purposes only and is not to be construed as rendering legal advice or accepting fees for legal advice. All templates, documents, forms and other materials accessible through this website are for demonstrative purposes. Your use of this website constitutes acceptance of The Complete Divorce’s Terms of Use, Supplemental Terms, Privacy Policy and Cookie Policy.
         </div>
         :
         <div>
         I understand that TCD Form Builder is to be used in conjunction with The Complete Divorce course program and that for best results, I need to follow the course program and complete the instructions for each step before completing the court forms.
I understand that the TCD Form Builder uses the information that I provide to fill the Judicial Council forms, but not all portions of the forms will be completed. I will need to use the TCD program to select the right responses for my specific case. It is my responsibility to make sure I have completed each form correctly.   [ X ] I agree
         </div>}
        
         </ModalBody>
         <ModalFooter>
           <Button color="primary" onClick={() =>modalinitial === 0 ? setModalinitial(1): toggle()}>I Accepted</Button>{' '}
           <Button color="secondary" onClick={toggle}>Cancel</Button>
         </ModalFooter>
    </Modal> 
  
       </div>
       
     
          
     
        );
}

const mapDispatchToProps = dispatch => {
  return {
    // dispatching plain actions
    getUsers: () => dispatch(getUsers()),
    getAdmins: () => dispatch(getAdmins()),
    getKuliahs: () => dispatch(getKuliahs()),
  }
}

const mapStateToProps =(state, ownProps, number)  =>({
      text: ownProps.text,
      icon: ownProps.icon,
      number: ownProps.number,
      users : state.dashboardReducer.users,
      admins : state.dashboardReducer.admins,
      kuliahs : state.dashboardReducer.kuliahs
    })

export default connect(mapStateToProps,mapDispatchToProps)(UserDashboard);